module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kc-Lb.a9bb3b71.png";